var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        value: _vm.value,
        fullscreen: _vm.$vuetify.breakpoint.smAndDown,
        "max-width": "900",
        scrollable: "",
      },
      on: {
        input: function ($event) {
          return _vm.$emit("input", $event)
        },
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "news-pdf__title" },
            [
              _c("span", { staticClass: "news-pdf__name" }, [
                _vm._v(_vm._s(_vm.attachment.name)),
              ]),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { icon: "", "aria-label": "Cerrar", title: "Cerrar" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("input", false)
                    },
                  },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-text",
            {
              staticClass: "news-pdf__body",
              on: {
                contextmenu: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _vm.loading
                ? _c(
                    "div",
                    { staticClass: "pa-6 text-center" },
                    [
                      _c("v-progress-circular", {
                        attrs: { indeterminate: "", color: "primary" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.error
                ? _c("p", { staticClass: "pa-6 text-center" }, [
                    _vm._v(_vm._s(_vm.error)),
                  ])
                : _vm._e(),
              _c("div", { ref: "pages", staticClass: "news-pdf__pages" }),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }